import { parseDashboardIdFromPath } from 'shared/utils/parseDashboardIdFromPath';

export const useDashboardId = () => {
  const dashboardId = parseDashboardIdFromPath(window.location.pathname);

  return { dashboardId };
};
